import { Input } from '@/components/form/Input';
import { Select } from '@/components/form/Select';
import { HelpText } from '@/components/ui/HelpText';
import { plural } from '@/lib/plural';
import useProductStore from '@/stores/productStore';

export const optionsBilling = [
  {
    label: 'Mensal',
    value: 'one_month'
  },
  {
    label: 'Trimestral',
    value: 'three_months'
  },
  {
    label: 'Semestral',
    value: 'six_months'
  },
  {
    label: 'Anual',
    value: 'twelve_months'
  },
  {
    label: 'Personalizada',
    value: 'custom'
  }
];

export const BillingCycle = () => {
  const payment = useProductStore(state => state.payment);

  return (
    <div className='flex flex-col gap-2'>
      <Select
        id='product-billing-cycle'
        label='Frequência de cobrança'
        values={optionsBilling}
        placeholder='Ciclo de cobrança'
        name='billingCycle'
      />
      {payment.billingCycle === 'custom' && (
        <>
          <div className='flex flex-1 flex-row gap-2'>
            <div className='w-full'>
              <Input
                id='subscription-billing-cycle-quantity'
                label='Quantidade'
                name='subscriptionBillingCycleQuantity'
                type='number'
                min={1}
                placeholder='Intervalo de cobrança'
              />
            </div>
            <div className='w-full'>
              <Select
                id='subscription-billing-cycle-type'
                label='Frequência de cobrança'
                values={[
                  {
                    label: 'Mensal',
                    value: 'months'
                  },
                  {
                    label: 'Anual',
                    value: 'years'
                  }
                ]}
                placeholder='Ciclo de cobrança'
                name='subscriptionBillingCycleType'
              />
            </div>
          </div>
          <HelpText>
            Será feita uma cobrança a cada <strong>{payment.billingConfig?.value}</strong>{' '}
            <strong>
              {payment.billingConfig?.type === 'months'
                ? plural(payment.billingConfig?.value, 'mês', 'meses')
                : plural(payment.billingConfig?.value, 'ano', 'anos')}
            </strong>
          </HelpText>
        </>
      )}
    </div>
  );
};
